import { Component, Input, ViewChild } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { format, parse } from 'date-fns';
import { CONSTANTS } from '../../../constants/constants';
import { UntypedFormControl } from '@angular/forms';
import { NgxPopperjsDirective, NgxPopperjsPlacements } from 'ngx-popperjs';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { isValidDate } from 'rxjs/internal/util/isDate';
import { UtilsService } from '../../../services/utils.service';
import { DatepickerComponent } from '../datepicker/datepicker.component';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
})
export class DateInputComponent {
  @Input() public fc: UntypedFormControl;
  @Input() public label: string;
  @Input() public disabled: boolean = false;
  @Input() public minDate: NgbDateStruct | undefined;
  @Input() public maxDate: NgbDateStruct | undefined;

  @ViewChild('datepickerPopper') datepickerPopper: NgxPopperjsDirective;
  @ViewChild('datepicker') datepicker: DatepickerComponent;

  protected readonly NgxPopperjsPlacements = NgxPopperjsPlacements;

  public onFocus(): void {
    this.datepickerPopper.show();
    const date = parse(
      this.fc.value ?? '',
      CONSTANTS.DATE_DISPLAY_FORMAT,
      new Date()
    );

    if (isValidDate(date)) {
      this.datepicker?.datepicker.focusDate(
        UtilsService.dateToNgbDateStruct(date)
      );
    }
  }

  public onClickOutside(): void {
    this.datepickerPopper.hide();
  }

  public onDateSelection(date: NgbDate): void {
    const dateString = format(
      new Date(date.year, date.month - 1, date.day),
      CONSTANTS.DATE_DISPLAY_FORMAT
    );

    this.fc.setValue(dateString);
    this.datepickerPopper.hide();
  }
}
